import React, { Suspense } from 'react';

// eslint-disable-next-line @atlassian/relay/use-single-relay-environment
import { RelayEnvironmentProvider } from 'react-relay';

import { RelayEnvironment } from '@atlassian/atlassian-studio-common';
import { SentryErrorBoundary, setupSentryClient } from '@atlassian/atlassian-studio-observability';

import { AppSelector } from './AppSelector';
import { LoadingSpinner } from './common/ui/loading-spinner';
import { redirectToLogin } from './common/utils/redirect-utils';

setupSentryClient({
	packageName: '@atlassian/studio-foundations',
});

export const WrappedApp = () => {
	return (
		<Suspense fallback={<LoadingSpinner size="large" />}>
			<RelayEnvironmentProvider environment={RelayEnvironment}>
				<SentryErrorBoundary fallbackComponent={() => null} onError={redirectToLogin}>
					<AppSelector />
				</SentryErrorBoundary>
			</RelayEnvironmentProvider>
		</Suspense>
	);
};
